<!--  -->
<template>
  <div>
    <!-- <div class="headBlock">
      <div class="header">
        <div class="left-box grace-flex-center-center left">
          <img
            class="icon40"
            src="../../assets/images/index/icon0.png"
            alt=""
          />
          <span class="title">城市管理网格员职业技能等级考试-考试入口</span>
        </div>
        <div class="right-box grace-space-between-center right">
          <el-link>考试资讯</el-link>
          <el-link>考评员库</el-link>
          <el-link href="#/login">登录</el-link>
        </div>
      </div>
    </div> -->
    <p class="app-title">全科网格员VR智慧实训平台</p>
    <div class="loginBox">
      <div class="title">登录</div>
      <div class="iptBox grace-columns">
        <el-input v-model="username" placeholder="用户名"></el-input>
        <el-input
          placeholder="密码"
          v-model="password"
          show-password
        ></el-input>
<!--        <el-checkbox v-model="remember">记住密码</el-checkbox>-->
      </div>
      <el-button class="loginBtn" type="primary" @click="myLogin()"
        >登录</el-button
      >
    </div>
<!--    <footer-bar class="foot"></footer-bar>-->
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import api from "@/utils/api";
import utils from "@/utils";
// import FooterBar from "./components/FooterBar";
export default {
  data() {
    return {
      username: "",
      password: "",
      remember: false,
    };
  },

  components: {
    // FooterBar,
  },

  computed: {
    // ...mapGetters({
    //   userInfo: "userInfo",
    // }),
  },

  mounted() {
    // setTimeout(() => {
    //   this.download();
    // }, 1000);

    // this.username = localStorage.getItem('username');
    // this.password = localStorage.getItem('password');
    // let saveUser = localStorage.getItem('userInfo');
    // let userInfo = saveUser?JSON.parse(saveUser):"";
    // if(userInfo && userInfo.token){
    //   this.$router.push("/BigscreenSetting");
    // }
  },

  methods: {
    // ...mapActions({
    //   login: "login",
    //   // getRegionList: "getRegionList",
    // }),
     myLogin() {
        let param ={
            name:this.username,
            pwd:this.password
        }
       api.login(param).then(res=>{
         if(res.code==1){
           api.getUserInfo(res.data.token).then(res=>{

             if(res.code==1){
               this.$router.replace(
                 `/question?id=${res.data.id}&name=${res.data.name}`
               );
               return this.$message.success('登录成功！');
             }else{
               return this.$message.error('登录失败！');
             }


           });

         }else{
           return this.$message.error(res.msg);
         }
       })



    },
  },
};
</script>
<style lang="scss" scoped>
  .app-title{
    color: #fff;
    top: 10%;
    font-size: 26px;
    position: absolute;
    width: 100%;
  }
.login-box {
  width: 100%;
  margin: 0 auto;
}
.loginBox {
  width: 80%;
  height: 310px;
  border: 1px solid #333;
  position: absolute;
  left: 50%;
  top: 50%;
  background-color: white;
  transform: translate(-50%, -50%);
  .title {
    width: 100%;
    height: 100px;
    line-height: 100px;
    font-size: 30px;
    font-weight: bold;
    color: cornflowerblue;
    text-align: center;
  }
  .iptBox {
    padding: 0 10%;
    height: 100px;
    justify-content: space-between;
    text-align: left;
    .el-input {
      width: 100%;
    }
  }
  .loginBtn {
    width: 160px;
    margin-top: 20px;
  }
}
.foot{
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Login/login.vue